import React, { useState, useEffect } from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo_colorido from '../logo_h.png';
import logo from './../logo.png';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import 'primeicons/primeicons.css';
import Alertas from "./../alertas";
import { ProgressBar } from 'primereact/progressbar';
import DadosMulher from "./steps/dados_mulher";
import DadosAutorViolencia from "./steps/dados_autor_violencia";
import Violencias from "./steps/violencias";
import Providencias from "./steps/providencias";
import RegistroOcorrencia from "./steps/registro_ocorrencia";
import InfoRelato from "./steps/infos_relato";
import FinalPedido from "./steps/final";

import api from "./../api";

function FormAlertaMulher() {

  const [fraseTopo, setFraseTopo] = useState("");
  const [stage, setStage] = useState(1);
  const [stageContainer, setStageContainer] = useState(null);
  const [load, setLoad] = useState(false);

  const [nome, setNome] = useState("");
  const [dataNasc, setDataNasc] = useState("");
  const [cpf, setCpf] = useState("");
  const [telefone, setTelefone] = useState("");
  const [concorda_telefone, setConcordaTelefone] = useState(false);
  const [email, setEmail] = useState("");
  const [concorda_email, setConcordaEmail] = useState(false);
  const [cepCasa, setCepCasa] = useState("");
  const [ruaCasa, setRuaCasa] = useState("");
  const [numeroCasa, setNumeroCasa] = useState("");
  const [compCasa, setCompCasa] = useState("");
  const [file_rg, setFile_rg] = useState(null);

  const [parentescoAutor, setParentescoAutor] = useState(null);
  const [nomeAutor, setNomeAutor] = useState("");
  const [dataNascAutor, setDataNascAutor] = useState("");
  const [cpfAutor, setCpfAutor] = useState("");
  const [telefoneAutor, setTelefoneAutor] = useState("");
  const [emailAutor, setEmailAutor] = useState("");
  const [cepCasaAutor, setCepCasaAutor] = useState("");
  const [ruaCasaAutor, setRuaCasaAutor] = useState("");
  const [numeroCasaAutor, setNumeroCasaAutor] = useState("");
  const [compCasaAutor, setCompCasaAutor] = useState("");
  const [file_rg_autor, setFile_rg_autor] = useState(null);

  const [violeciasSofridas, setViolenciasSofridas] = useState([]);
  const [periodoSofrido, setPeriodoSofrido] = useState([]);
  const [frequenciaSofrida, setFrequenciaSofrida] = useState([]);
  const [outraFrequencia, setOutraFrequencia] = useState("");

  const [providencias, setProvidencias] = useState([]);
  const [outraProvidencia, setOutraProvidencia] = useState("");
  const [motivos, setMotivos] = useState([]);
  const [outroMotivo, setOutroMotivo] = useState("");

  const [regOcorrencia, setRegOcorrencia] = useState([]);
  const [medidaProtetiva, setMedidaProtetiva] = useState([]);
  const [descumpriu, setDescumpriu] = useState([]);
  const [terceiroVitima, setTerceiroVitima] = useState([]);
  const [descrTerceiro, setDescrTerceiro] = useState("");
  const [agressaoFilhos, setAgressaoFilhos] = useState([]);
  const [presencaFilhos, setPresencaFilhos] = useState([]);

  const [infos, setInfos] = useState("");
  const [contribuicaoDPE, setContribuicaoDPE] = useState("");

  useEffect(() => {
    switch (stage) {
      case 1:
        setStageContainer(
          <DadosMulher
            setFraseTopo={setFraseTopo}
            setStage={setStage}
            nome={nome}
            dataNasc={dataNasc}
            cpf={cpf}
            telefone={telefone}
            concorda_telefone={concorda_telefone}
            email={email}
            concorda_email={concorda_email}
            cepCasa={cepCasa}
            ruaCasa={ruaCasa}
            numeroCasa={numeroCasa}
            compCasa={compCasa}
            file_rg={file_rg}
            setNome={setNome}
            setDataNasc={setDataNasc}
            setCpf={setCpf}
            setTelefone={setTelefone}
            setConcordaTelefone={setConcordaTelefone}
            setEmail={setEmail}
            setConcordaEmail={setConcordaEmail}
            setCepCasa={setCepCasa}
            setRuaCasa={setRuaCasa}
            setNumeroCasa={setNumeroCasa}
            setCompCasa={setCompCasa}
            setFile_rg={setFile_rg}
          />
        );
        break;

      case 2:
        setStageContainer(
          <DadosAutorViolencia
            setFraseTopo={setFraseTopo}
            setStage={setStage}
            parentescoAutor={parentescoAutor}
            nomeAutor={nomeAutor}
            dataNascAutor={dataNascAutor}
            cpfAutor={cpfAutor}
            telefoneAutor={telefoneAutor}
            emailAutor={emailAutor}
            cepCasaAutor={cepCasaAutor}
            ruaCasaAutor={ruaCasaAutor}
            numeroCasaAutor={numeroCasaAutor}
            compCasaAutor={compCasaAutor}
            file_rg_autor={file_rg_autor}
            setParentescoAutor={setParentescoAutor}
            setNomeAutor={setNomeAutor}
            setDataNascAutor={setDataNascAutor}
            setCpfAutor={setCpfAutor}
            setTelefoneAutor={setTelefoneAutor}
            setEmailAutor={setEmailAutor}
            setCepCasaAutor={setCepCasaAutor}
            setRuaCasaAutor={setRuaCasaAutor}
            setNumeroCasaAutor={setNumeroCasaAutor}
            setCompCasaAutor={setCompCasaAutor}
            setFile_rg_autor={setFile_rg_autor}
          />);
        break;

      case 3:
        setStageContainer(
          <Violencias
            setFraseTopo={setFraseTopo}
            setStage={setStage}
            violeciasSofridas={violeciasSofridas}
            periodoSofrido={periodoSofrido}
            frequenciaSofrida={frequenciaSofrida}
            outraFrequencia={outraFrequencia}
            setViolenciasSofridas={setViolenciasSofridas}
            setPeriodoSofrido={setPeriodoSofrido}
            setFrequenciaSofrida={setFrequenciaSofrida}
            setOutraFrequencia={setOutraFrequencia}
          />);
        break;

      case 4:
        setStageContainer(
          <Providencias
            setFraseTopo={setFraseTopo}
            setStage={setStage}
            providencias={providencias}
            outraProvidencia={outraProvidencia}
            motivos={motivos}
            outroMotivo={outroMotivo}
            setProvidencias={setProvidencias}
            setOutraProvidencia={setOutraProvidencia}
            setMotivos={setMotivos}
            setOutroMotivo={setOutroMotivo}

          />);
        break;

      case 5:
        setStageContainer(
          <RegistroOcorrencia
            setFraseTopo={setFraseTopo}
            setStage={setStage}
            regOcorrencia={regOcorrencia}
            medidaProtetiva={medidaProtetiva}
            descumpriu={descumpriu}
            terceiroVitima={terceiroVitima}
            descrTerceiro={descrTerceiro}
            agressaoFilhos={agressaoFilhos}
            presencaFilhos={presencaFilhos}
            setRegOcorrencia={setRegOcorrencia}
            setMedidaProtetiva={setMedidaProtetiva}
            setDescumpriu={setDescumpriu}
            setTerceiroVitima={setTerceiroVitima}
            setDescrTerceiro={setDescrTerceiro}
            setAgressaoFilhos={setAgressaoFilhos}
            setPresencaFilhos={setPresencaFilhos}
          />
        );
        break;

      case 6:
        setStageContainer(
          <InfoRelato
            setFraseTopo={setFraseTopo}
            setStage={setStage}
            infos={infos}
            contribuicaoDPE={contribuicaoDPE}
            setInfos={setInfos}
            setContribuicaoDPE={setContribuicaoDPE}
            enviar_email={enviar_email}
          />

        );
        break;

      case 7:
        setStageContainer(
          <FinalPedido
            setFraseTopo={setFraseTopo}
          />
        );
        break;

      default:
        break;
    }

  }, [stage, nome, dataNasc, cpf, telefone, concorda_telefone, email, concorda_email, cepCasa, ruaCasa, numeroCasa, compCasa, file_rg,
    parentescoAutor, nomeAutor, dataNascAutor, cpfAutor, telefoneAutor, emailAutor, cepCasaAutor, ruaCasaAutor, numeroCasaAutor, compCasaAutor, file_rg_autor,
    violeciasSofridas, periodoSofrido, frequenciaSofrida, outraFrequencia,
    providencias, outraProvidencia, motivos, outroMotivo,
    regOcorrencia, medidaProtetiva, descumpriu, terceiroVitima, descrTerceiro, agressaoFilhos, presencaFilhos,
    infos, contribuicaoDPE
  ]);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    }
  };

  function generatePDF() {
    let data = new Date();
    let doc = new jsPDF('p', 'pt');
    let pageWidth = doc.internal.pageSize.getWidth();

    let logoWidth = 200;
    let logoHeight = 40;
    let logoX = (pageWidth - logoWidth) / 2; // Centraliza o logo com base na largura da página
    doc.addImage(logo_colorido, 'PNG', logoX, 20, logoWidth, logoHeight);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text('Resposta do Formulário Alerta Mulher', pageWidth / 2, 90, { align: 'center' });

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(14)
    doc.text(228, 110, `${data.getDate()}/${data.getMonth() + 1}/${data.getFullYear()} - ${data.toLocaleTimeString()}`)

    doc.setFontSize(10)

    let violenciasSofridasString = violeciasSofridas.map(violencia => violencia.name).join('; ');

    let providenciasString = providencias.map(providencia => providencia.name).join('; ');

    let motivosString = motivos.map(motivo => motivo.name).join('; ');

    const tableData = [
      { campo: 'Nome', valor: nome },
      { campo: 'Data de Nascimento', valor: dataNasc },
      { campo: 'CPF', valor: cpf },
      { campo: 'Telefone', valor: telefone },
      { campo: 'Receber notificação WhatsApp?', valor: concorda_telefone ? 'Sim' : 'Não' },
      { campo: 'E-mail', valor: email },
      { campo: 'Receber notificação via E-mail?', valor: concorda_email ? 'Sim' : 'Não' },
      { campo: 'CEP', valor: cepCasa },
      { campo: 'Rua', valor: ruaCasa },
      { campo: 'Número', valor: numeroCasa },
      { campo: 'Complemento', valor: compCasa },
      { campo: 'Parentesco com Autor', valor: parentescoAutor ? parentescoAutor.name : '' },
      { campo: 'Nome do Autor', valor: nomeAutor },
      { campo: 'Data de Nascimento do Autor', valor: dataNascAutor },
      { campo: 'CPF do Autor', valor: cpfAutor },
      { campo: 'Telefone do Autor', valor: telefoneAutor },
      { campo: 'Email do Autor', valor: emailAutor },
      { campo: 'CEP da Casa do Autor', valor: cepCasaAutor },
      { campo: 'Rua da Casa do Autor', valor: ruaCasaAutor },
      { campo: 'Número da Casa do Autor', valor: numeroCasaAutor },
      { campo: 'Complemento da Casa do Autor', valor: compCasaAutor },
      { campo: 'Violências Sofridas', valor: violenciasSofridasString },
      { campo: 'Período Sofrido', valor: periodoSofrido.name ? periodoSofrido.name : '' },
      { campo: 'Frequência Sofrida', valor: frequenciaSofrida.name ? frequenciaSofrida.name : '' },
      { campo: 'Outras Frequências', valor: outraFrequencia },
      { campo: 'Providências Tomadas', valor: providenciasString },
      { campo: 'Outras Providências', valor: outraProvidencia },
      { campo: 'Não denunciou porque:', valor: motivosString },
      { campo: 'Outros Motivos', valor: outroMotivo },
      { campo: 'Registrou Ocorrência?', valor: regOcorrencia },
      { campo: 'Possui Medida Protetiva?', valor: medidaProtetiva },
      { campo: 'Descumpriu Medida?', valor: descumpriu },
      { campo: 'Existe Outra Vítima?', valor: terceiroVitima },
      { campo: 'Descrição de terceiro (vítima)', valor: descrTerceiro },
      { campo: 'Agressão aos Filhos?', valor: agressaoFilhos.name ? agressaoFilhos.name : '' },
      { campo: 'Presença dos Filhos?', valor: presencaFilhos },
      { campo: 'Informações Adicionais', valor: infos },
      { campo: 'Contribuição da DPE', valor: contribuicaoDPE }
    ];

    autoTable(doc, {
      startY: 130,
      body: tableData.map(item => ({ campo: item.campo, valor: item.valor })),
      columns: [
        { header: 'Pergunta', dataKey: 'campo' },
        { header: 'Resposta', dataKey: 'valor' }
      ],
      columnStyles: {
        0: { cellWidth: 150 }, 
      },
      headStyles: {
        fillColor: [87, 16, 112], 
        textColor: [251, 244, 255], 
        fontSize: 12, 
      },
    });

    return doc.output('blob');
    //doc.output('dataurlnewwindow');

  }



  function enviar_email(step) {
    generatePDF();

    setLoad(true);
    const formData = new FormData();
    formData.append("nome", nome);
    formData.append("dataNasc", dataNasc);
    formData.append("cpf", cpf);
    formData.append("telefone", telefone);
    formData.append("concorda_telefone", concorda_telefone? 'Sim' : 'Não');
    formData.append("email", email);
    formData.append("concorda_email", concorda_email? 'Sim' : 'Não');
    formData.append("cepCasa", cepCasa);
    formData.append("ruaCasa", ruaCasa);
    formData.append("numeroCasa", numeroCasa);
    formData.append("compCasa", compCasa);

    formData.append("parentescoAutor", `${parentescoAutor ? parentescoAutor.name : ""}`);
    formData.append("nomeAutor", nomeAutor);
    formData.append("dataNascAutor", dataNascAutor);
    formData.append("cpfAutor", cpfAutor);
    formData.append("telefoneAutor", telefoneAutor);
    formData.append("emailAutor", emailAutor);
    formData.append("cepCasaAutor", cepCasaAutor);
    formData.append("ruaCasaAutor", ruaCasaAutor);
    formData.append("numeroCasaAutor", numeroCasaAutor);
    formData.append("compCasaAutor", compCasaAutor);

    formData.append("violeciasSofridas", JSON.stringify(violeciasSofridas));
    formData.append("periodoSofrido", `${periodoSofrido.name ? periodoSofrido.name : ""}`);
    formData.append("frequenciaSofrida", `${frequenciaSofrida.name ? frequenciaSofrida.name : ""}`);
    formData.append("outraFrequencia", outraFrequencia);

    formData.append("providencias", JSON.stringify(providencias));
    formData.append("outraProvidencia", outraProvidencia);
    formData.append("motivos", JSON.stringify(motivos));
    formData.append("outroMotivo", outroMotivo);

    formData.append("regOcorrencia", regOcorrencia);
    formData.append("medidaProtetiva", medidaProtetiva);
    formData.append("descumpriu", descumpriu);
    formData.append("terceiroVitima", terceiroVitima);
    formData.append("descrTerceiro", descrTerceiro);
    formData.append("agressaoFilhos", `${agressaoFilhos.name ? agressaoFilhos.name : ""}`);
    formData.append("presencaFilhos", presencaFilhos);

    formData.append("infos", infos);
    formData.append("contribuicaoDPE", contribuicaoDPE);

    const pdfBlob = generatePDF();
    formData.append('attachment_0', pdfBlob, `ALERTA_${nome}.pdf`);

    if (file_rg) {
      formData.append("attachment_1", file_rg);
    }

    if (file_rg_autor) {
      formData.append("attachment_2", file_rg_autor);
    }


    api.post('/email_alerta_mulher/', formData, config)
      .then((res) => {
        if (res.data == 200) {
          setLoad(false);
          Alertas.sucesso("Dados enviados com sucesso.");
        } else {
          setLoad(false);
          setStage(step);
        }
      }).catch((err) => {
        setLoad(false);
        Alertas.erro(err.Motivo);
      })
  }

  const valueTemplate = () => {
    return (<span className="value-bar-mulher">{stage == 7 ? <strong>Completo</strong> : `${stage}/6`}</span>);
  };

  return (
    <div className="App App-mulher">
      <Dialog
        visible={load}
        style={{ width: '70vw' }}
        closable={false}
        closeOnEscape={false}
        draggable={false}
      >
        <div className="load-spinner">
          <ProgressSpinner />
          <p>Preparando dados para o envio...</p>
        </div>
      </Dialog>

      <div className="app-nav-mulher">
        <img src={logo} className="nav-logo-mulher" alt="logo-dpe" />
        <p className="card-texto-mulher">
          Alerta Mulher
        </p>
      </div>
      <div className="app-nav-mulher-2">
        <span className="frase-mulher">{fraseTopo}</span>
        <div className="progress-bar-mulher">
          <ProgressBar value={(stage / 7) * 100} displayValueTemplate={valueTemplate}></ProgressBar>
        </div>
      </div>
      {stageContainer}
    </div>
  );
}

export default FormAlertaMulher;
